import { Brick, registerBrick, WorkflowObjectState, Transaction, CloudObject, Auth, User } from 'olympe';
import BCP from './DM_BCP.js';
import { BCP_WORKFLOW_STATES, getCurrentWorkflow }
    from './BcpWorkflowAuthorizations';
import { executeLambda, getLogger } from "@olympeio/core";
import { getApplicationContext } from '../../common/utils/Context.js';

export default class RejectMultipleBCPRequests extends Brick {


    /* Helper function to execute a Lambda and return its result.
   */
    async getLambdaResult($, lambdaName, bcpRequest, map) {
        // const result = await executeLambda($, lambdaName, [actionName, userKey, emailKey]);
        const result = await executeLambda($, lambdaName, [bcpRequest, map]);
        return JSON.parse(JSON.stringify(result));
    }
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} rejectBCPRequest
     * @param {*} bCPRequests
     * @param {string} adminFirstIndicator
     * @param {string} bPPMRejectionReasonCode
     * @param {string} cTAGQARejectionReasonCode
     * @param {function()} forwardEvent
     * @param {function(boolean)} setRequestRejectionStatus
     * @param {string} rejectionReasonComment
     */
    async update($, [rejectBCPRequest, bCPRequests, adminFirstIndicator, bPPMRejectionReasonCode, cTAGQARejectionReasonCode,rejectionReasonComment], [forwardEvent, setRequestRejectionStatus]) {
        // Write your code here.
        // Check https://olympe.support for documentation.
        // Write your code here.
        // Loop over the number of BCP requests and call the lambda to accpet the individual request
        const loggedInUserMail = CloudObject.get(Auth.getCurrentUser()).get(User.loginProp);
        const logger = getLogger('AcceptMultipleBCPRequest');
        const applicationContext = getApplicationContext($);
        for (const [key, bcpRequest] of Object.entries(bCPRequests)) {
            const roles = {
                businessPartner: bcpRequest.get(BCP.businessPartnerProp),
                procurementManager: bcpRequest.get(BCP.procurementManagerProp),
                ctagPerson: bcpRequest.get(BCP.technicalApplicationGroupProp),
                sqaPerson: bcpRequest.get(BCP.qualityAssuranceProp),
                qaFactoryPerson: bcpRequest.get(BCP.qaInFactoryProp),
            };
            try {
                const currentState = getCurrentWorkflow(bcpRequest, $)?.get(
                    WorkflowObjectState.stateProp
                );
                const t1 = new Transaction(true);
                switch (currentState) {
                    case BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP:
                    case BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM:
                        BCP.setRejectedNote(t1, bcpRequest, bPPMRejectionReasonCode);
                        BCP.setRejectionReasonComment(t1, bcpRequest, rejectionReasonComment)
                        break;
                    case BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE:
                    case BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1:
                    case BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2:
                    case BCP_WORKFLOW_STATES.WAITING_ON_COMPLETION:
                        BCP.setRejectedNote(t1, bcpRequest, cTAGQARejectionReasonCode);
                        BCP.setRejectionReasonComment(t1, bcpRequest, rejectionReasonComment)
                        break;
                        // for non-admin user we need to check if the logged in user trying to accept                    
                    default:
                        break;
                }
                const dbExecuteResult = await t1.execute()
                logger.info("::::: Execute Result ::::", dbExecuteResult)

                // For BP, PM, and other QA stakholder we need to call following method to accept
                try {
                    const rejectStatus = await this.getLambdaResult($, rejectBCPRequest, bcpRequest, null);
                    logger.info(":::::: Reject Lambda Result :::::::", rejectStatus)
                    
                } catch (error) {
                    setRequestRejectionStatus(false)
                    logger.error("Error happened while rejecting multiple BCP Request:1", error);
                    // Handle errors during the send email process
                    throw new Error(`Error in accepting workflow for BCP:${error}`);
                }

            } catch (error) {
                setRequestRejectionStatus(false)
                logger.error("Error happened while deleting multiple BCP Request:2", error);
                // Handle errors during the send email process
                throw new Error(`Error in accepting workflow for BCP:${error}`);
            }
        }
        applicationContext.set('selectedBCPs', [])
        setRequestRejectionStatus(true)
        forwardEvent();
    }
}

registerBrick('01980e6b23d47df50cfa', RejectMultipleBCPRequests);
